import { HttpBackend, HttpClient, HttpHandler, HttpXhrBackend } from "@angular/common/http";
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import { Injectable } from '@angular/core';
import { DwConfigLoader } from '@devwareapps/devware-cap/devware-core/config/models/dw-config-loader';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class ConfigService implements DwConfigLoader {
  public static config: Config;
  constructor(private httpBackend: HttpBackend = null){

  }

  loadConfig(): Observable<any> {
    const httpClient = new HttpClient(this.httpBackend);

    return httpClient.get<Config>('/environments/environment.json')
      .pipe(tap(config=> {
        config.features = config.features || { };

        // Default PAF to true if omitted from settings
        if (!config.features.paf) {
          config.features.paf = {workflowPort: true };
        }

        ConfigService.config = config;
      },
      catchError((err) =>{  
        return of({});
      })
      ));

    /* const httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
    return await httpClient
      .get<Config>('./environments/environment.json')
      .toPromise().then(config => {
        this.config = config
      }) */
  }

  get config(): Config{
    return ConfigService.config || {} as any;
  }
}

export class Config{
  production: boolean;
  apiRoot: string;
  showContactUs: boolean;
  contactUsEmail: string;
  showPrototypes: boolean;
  allowConfiguration: boolean;
  baseTitle: string;
  enableConsoleLogging: boolean;
  environmentMessage: string;
  emailSendToCurrentUserOnly: boolean;
  wAppsApi: string;
  tenantKey: string;
  trustBaseUrl: string;
  features: {
    paf : { workflowPort : boolean }
    gridIncludeQuickSearch?: boolean
  }
}
